export default "__VITE_ASSET__BmyjIvGN__"